import React, { Component } from 'react';
import { Package, MapPin, Smartphone } from 'lucide-react';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
import { WA_NUMBER } from '../data/products';
export function FinalCTA() {
  const waLink = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent('Hola! Vi el 20% OFF en AlphaFit y quiero saber más sobre los suplementos')}`;
  return <section className="bg-gradient-to-b from-dark-900 via-[#1a1500] to-[#080808] py-[100px] px-5 text-center" data-id="element-110" data-mp="87js0fnfcgiv">
      <div className="max-w-[1100px] mx-auto" data-id="element-111" data-mp="h5vdk39foo4g">
        <h2 className="text-[clamp(2rem,5vw,3.5rem)] font-black uppercase tracking-[3px] mb-[15px] leading-[1.1] text-white" data-id="element-112" data-mp="h52frrsgd8yg">
          ¿Seguís Esperando o<br data-id="element-113" data-mp="qvoqb7lbb9aa" />
          <span className="text-alphaGold" data-id="element-114" data-mp="qvx5x78tksp6">Empezás Hoy?</span>
        </h2>

        <p className="text-[#aaa] text-[1.1rem] max-w-[600px] mx-auto mb-[40px] leading-[1.7]" data-id="element-115" data-mp="qy15xe3ll7k6">
          Cada día que pasa es un entrenamiento sin el combustible que tu cuerpo
          merece. El 20% OFF no dura para siempre. Tu físico ideal no llega solo
          — pero con los suplementos correctos, llega mucho más rápido.
        </p>

        <div className="flex justify-center flex-wrap gap-4" data-id="element-116" data-mp="2h2y7zbopcftx">
          <a href={waLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 bg-whatsapp text-white text-[1rem] font-extrabold py-[18px] px-10 rounded uppercase tracking-[1px] transition-all duration-200 shadow-[0_6px_30px_rgba(37,211,102,0.35)] hover:-translate-y-[3px] hover:shadow-[0_10px_40px_rgba(37,211,102,0.5)]" data-id="element-117" data-mp="2m2uaf6hr3z7d">
            <WhatsAppIcon className="w-[22px] h-[22px]" data-id="element-118" data-mp="34tlo2k8rubrk" />
            Pedir por WhatsApp — 20% OFF
          </a>
        </div>

        <div className="flex items-center justify-center gap-4 flex-wrap text-[#444] text-[0.85rem] mt-[25px]" data-id="element-119" data-mp="39rdj3n4pqdzz">
          <span className="flex items-center gap-1.5" data-id="element-120" data-mp="3et2vp77l2zq6">
            <Package className="w-4 h-4" data-id="element-121" data-mp="3istrxqfvq823" /> Envío a domicilio desde $190 UY
          </span>
          <span className="hidden sm:inline" data-id="element-122" data-mp="1jod0qlp67e08">·</span>
          <span className="flex items-center gap-1.5" data-id="element-123" data-mp="1jov21wqowif0">
            <MapPin className="w-4 h-4" data-id="element-124" data-mp="1eps93anzi2ne" /> Pick Up en Malvín
          </span>
          <span className="hidden sm:inline" data-id="element-125" data-mp="1enfhs6wc6fxo">·</span>
          <span className="flex items-center gap-1.5" data-id="element-126" data-mp="1shgkfbqesn3b">
            <Smartphone className="w-4 h-4" data-id="element-127" data-mp="1npyfkcl9m2d2" /> +{WA_NUMBER.substring(0, 3)}{' '}
            {WA_NUMBER.substring(3, 5)} {WA_NUMBER.substring(5, 8)}{' '}
            {WA_NUMBER.substring(8)}
          </span>
        </div>
      </div>
    </section>;
}